import { useState } from 'react'
import { Star } from 'lucide-react'
import { client } from 'utils/api-client'
import { Toast } from './Toast'

export const ReviewForm = ({ productId }: { productId?: string }) => {
  const [commentText, setCommentText] = useState('')
  const [rating, setRating] = useState(0)
  const [toastMessage, setToastMessage] = useState<string | null>(null)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const data = {
      rating,
      comment: commentText,
    }
    const result = await client(`products/${productId}/reviews`, { data })
    if (result) {
      setToastMessage(`نظر شما ثبت شد!\nامتیاز: ${rating} ستاره`)
    }
    setCommentText('')
    setRating(0)
  }

  return (
    <form onSubmit={handleSubmit} className='mt-6'>
      {toastMessage && (
        <Toast message={toastMessage} onDismiss={() => setToastMessage(null)} />
      )}
      <div className='flex items-center mb-4'>
        <p className='text-base font-medium' style={{ color: 'var(--text-secondary)' }}>امتیاز شما:</p>
        <div className='flex items-center mr-2'>
          {[...Array(5)].map((_, i) => {
            const ratingValue = i + 1
            return (
              <button
                type='button'
                key={ratingValue}
                onClick={() => setRating(ratingValue)}
                className='focus:outline-none'
                aria-label={`امتیاز ${ratingValue} از 5`}
              >
                <Star
                  className={`cursor-pointer transition-colors ${
                    ratingValue <= rating ? 'text-yellow-400 fill-current' : ''
                  }`}
                  style={{ color: ratingValue <= rating ? undefined : 'var(--text-tertiary)' }}
                  size={24}
                  strokeWidth={1.5}
                />
              </button>
            )
          })}
        </div>
      </div>
      <h3 className='text-lg font-semibold mb-2' style={{ color: 'var(--text-primary)' }}>
        نظر خود را بنویسید
      </h3>
      <textarea
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        className='input-theme w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
        rows={4}
        placeholder='نظر خود را در مورد این کتاب به اشتراک بگذارید...'
        required
      />
      <button
        type='submit'
        className='mt-4 w-full md:w-auto px-6 py-3 text-white font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105'
        style={{ backgroundColor: 'var(--accent-primary)' }}
      >
        ارسال نظر
      </button>
    </form>
  )
}
